export { withAssetLogic } from './withAssetLogic';
